import React from 'react';
import { useTranslation } from 'react-i18next';
import LabeledText from 'commons/src/components/LabeledText';
import { BuildingType } from 'commons/src/models/commonTypeScript';
import { ReportSectionWrapper } from '../../../components/wrappers';
import styles from './IAQInsight2BuildingInfo.module.scss';

export type IAQInsight2BuildingInfoProps = {
    building: BuildingType;
};

const IAQInsight2BuildingInfo: React.FC<IAQInsight2BuildingInfoProps> = ({ building }) => {
    const { t: txt } = useTranslation();

    return (
        <ReportSectionWrapper>
            <div className={styles.formFieldMediumSlim}>
                <LabeledText
                    label="BuildingType"
                    largeText
                    id="buildingType"
                    value={
                        (building &&
                            building.buildingType &&
                            txt(`BuildingTypeOptions.${building.buildingType.toString()}`)) ||
                        'Apartment'
                    }
                />
            </div>
            <div className={styles.formFieldMediumSlim}>
                <LabeledText
                    label="BuildingYear"
                    largeText
                    id="buildingYear"
                    value={(building && building.buildingYear && building.buildingYear.toString()) || '2002'}
                />
            </div>
            <div className={styles.formFieldMediumSlim}>
                <LabeledText
                    label="Ventilation"
                    id="ventilation"
                    largeText
                    value={
                        (building &&
                            building.ventilationType &&
                            txt(`VentilationTypeOptions.${building.ventilationType.toString()}`)) ||
                        'Mechanical'
                    }
                />
            </div>
            <div className={styles.formFieldMediumSlim}>
                <LabeledText
                    label="NumberOfFloors"
                    id="numberOfFloors"
                    largeText
                    value={(building && building.floors && building.floors.toString()) || '8'}
                />
            </div>
        </ReportSectionWrapper>
    );
};

export default IAQInsight2BuildingInfo;
